import { Input } from "design-react-kit";
import { useEffect, useState, useContext } from "react";
import Repo from "../../Utility/Repo";
import { Link, useLocation } from "react-router-dom";
import Select from "../../Components/Select";
import { PROVINCE } from "../../Components/listaProvince";
import { NAZIONI } from "../../Components/listaNazioni";
import { TokenContext } from "../../Components/TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useRef } from "react";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function AddAssistito(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [validation, setValidation] = useState(false);
  const [validationBirth, setValidationBirth] = useState(true);

  const [assistito, setAssistito] = useState({});
  const [redditiISEE, setRedditiISEE] = useState({});

  const [condizioniAbitative, setCondizioniAbitative] = useState({});
  const [componentiNucleoFamiliare, setComponentiNucleoFamiliare] = useState(
    {}
  );
  const [interventiSocioAssistenziali, setInterventiSocioAssistenziali] =
    useState({});
  const [anamnesiFamiliari, setAnamnesiFamiliari] = useState({});

  const [loading, setLoading] = useState(true);

  const [isDisabled, setIsDisabled] = useState(true);
  const [listaProvince] = useState(PROVINCE);
  const [listaNazioni] = useState(NAZIONI);
  const [listaMunicipi, setListaMunicipi] = useState();

  const ref = useRef();

  let query = useQuery();

  const handleGoBack = () => {
    window.history.back(); // Questo torna indietro nella storia del browser
  };

  //nuovo codice

  /**
  "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  "nome": "string",
  "cognome": "string",
  "dataNascita": "2023-10-03T08:36:37.107Z",
  "comuneResidenza": "string",
  "telefono": "string",
  "sesso": "string",
  "domicilio": "string",
  "codiceFiscale": "string",
  "cittadinanzaItaliana": true,
  "altraCittadinanza": true,
  "possessoPermessoSoggiorno": true,
  "possessoCartaSoggiorno": true,
  "statoCivile": 1,
 */
  const [showModalAdd, setshowModalAdd] = useState(false);
  const [showModalModify, setshowModalModify] = useState(false);

  const [error, setError] = useState("");

  const userId = query.get("userId") != null ? query.get("userId") : "0";

  const initialFormData = {
    nome: "",
    cognome: "",
    dataNascita: "",
    comuneResidenza: "",
    telefono: "",
    sesso: "",
    domicilio: "",
    codiceFiscale: "",
    cittadinanzaItaliana: false,
    altraCittadinanza: false,
    possessoPermessoSoggiorno: false,
    possessoCartaSoggiorno: false,
    statoCivile: 0,
    userId: userId,
    errorMessages: {},
  };
  const [formData, setFormData] = useState(initialFormData);

  const toggleModalModify = () => {
    setshowModalModify(!showModalModify);
  };

  const resetFormFields = () => {
    setFormData(initialFormData);
    setError("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      errorMessages: {},
    }));
  };

  const showModify = (ogg) => {
    formData.nome = ogg.nome;
    formData.cognome = ogg.cognome;
    formData.dataNascita = ogg.dataNascita;
    formData.comuneResidenza = ogg.comuneResidenza;
    formData.telefono = ogg.telefono;
    formData.sesso = ogg.sesso;
    formData.domicilio = ogg.domicilio;
    formData.codiceFiscale = ogg.codiceFiscale;
    formData.cittadinanzaItaliana = ogg.cittadinanzaItaliana === 1;
    formData.altraCittadinanza = ogg.altraCittadinanza === 1;
    formData.possessoPermessoSoggiorno = ogg.possessoPermessoSoggiorno === 1;
    formData.possessoCartaSoggiorno = ogg.possessoCartaSoggiorno === 1;
    formData.statoCivile = ogg.statoCivile;
    formData.userId = userId;
    setshowModalModify(true);
  };

  const handleCloseModalModify = () => {
    setshowModalModify(false);
    resetFormFields();
  };

  const handleUpdate = () => {
    const errors = validateForm();

    if (Object.keys(errors).length === 0) {
      setError("");
      // Nessun errore, procedi con l'aggiornamento
      Repo.AddAssistito(apiToken, JSON.stringify(formData))
        .then((response) => {
          if (response.status === 200) {
            // onUpdate(formData);
            setError("Utente inserito con successo");
          }
        })
        .catch((error) => {
          setError(error.response?.data?.Message || error.response?.data || "");
        });
    } else {
      // Ci sono errori, aggiorniamo lo stato con i messaggi di errore
      setFormData({ ...formData, errorMessages: errors });
    }
  };

  const handleChangeCheckbox = (property, value) => {
    setFormData({ ...formData, [property]: value });
  };

  const validateForm = () => {
    const errors = {};

    // Esempio di validazione del campo nome
    if (!formData.nome) {
      errors.nome = "Il campo nome è obbligatorio";
    }
    if (!formData.cognome) {
        errors.cognome = "Il campo cognome è obbligatorio";
      }

    // Aggiungi altre regole di validazione per gli altri campi

    return errors;
  };

  //fine nuovo codice

  return (
    <>
      <div>
        <h1>Aggiungi assistito</h1>

        <div className="row">
          <div className="clearfix col-lg-8 py-lg-2">
            <p>Inserisci tutte le informazioni per l'assistito</p>
          </div>
          <div className="col-lg-4 d-flex justify-content-end">
            <div>
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => handleGoBack()}
              >
                Indietro
              </button>
            </div>
          </div>
        </div>

        <div className="col-lg-12 mt-3">
          <div className="card-wrapper card-space">
            <div className="card card-bg no-after card-big roundedCustom">
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-12">
                    <div>
                      <label htmlFor="nome">Nome:*</label>
                      <input
                        type="text"
                        id="nome"
                        name="nome"
                        value={formData.nome}
                        onChange={handleChange}
                      />
                      {formData.errorMessages.nome && (
                        <span style={{ color: "red" }}>
                          {formData.errorMessages.nome}
                        </span>
                      )}
                    </div>
                    <div>
                      <label htmlFor="cognome">Cognome:*</label>
                      <input
                        type="text"
                        id="cognome"
                        name="cognome"
                        value={formData.cognome}
                        onChange={handleChange}
                      />
                      {formData.errorMessages.cognome && (
                        <span style={{ color: "red" }}>
                          {formData.errorMessages.cognome}
                        </span>
                      )}
                    </div>
                    <div>
                      <label htmlFor="dataNascita">Data di Nascita:</label>
                      <input
                        type="date"
                        id="dataNascita"
                        name="dataNascita"
                        value={Repo.convertiFormatoData(formData.dataNascita)}
                        onChange={handleChange}
                      />
                    </div>

                    <div>
                      <label htmlFor="comuneResidenza">comuneResidenza:</label>
                      <input
                        type="text"
                        id="comuneResidenza"
                        name="comuneResidenza"
                        value={formData.comuneResidenza}
                        onChange={handleChange}
                      />
                    </div>

                    <div>
                      <label htmlFor="telefono">telefono:</label>
                      <input
                        type="text"
                        id="telefono"
                        name="telefono"
                        value={formData.telefono}
                        onChange={handleChange}
                      />
                    </div>

                    <div>
                      <label htmlFor="sesso">sesso:</label>
                      <input
                        type="text"
                        id="sesso"
                        name="sesso"
                        value={formData.sesso}
                        onChange={handleChange}
                      />
                    </div>

                    <div>
                      <label htmlFor="domicilio">domicilio:</label>
                      <input
                        type="text"
                        id="domicilio"
                        name="domicilio"
                        value={formData.domicilio}
                        onChange={handleChange}
                      />
                    </div>

                    <div>
                      <label htmlFor="codiceFiscale">codiceFiscale:</label>
                      <input
                        type="text"
                        id="codiceFiscale"
                        name="codiceFiscale"
                        value={formData.codiceFiscale}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="cittadinanzaItaliana"
                        onChange={(e) =>
                          handleChangeCheckbox(
                            "cittadinanzaItaliana",
                            e.target.checked
                          )
                        }
                        checked={formData.cittadinanzaItaliana}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="cittadinanzaItaliana"
                      >
                        Cittadinanza Italiana
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="altraCittadinanza"
                        onChange={(e) =>
                          handleChangeCheckbox(
                            "altraCittadinanza",
                            e.target.checked
                          )
                        }
                        checked={formData.altraCittadinanza}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="altraCittadinanza"
                      >
                        altra Cittadinanza
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="possessoPermessoSoggiorno"
                        onChange={(e) =>
                          handleChangeCheckbox(
                            "possessoPermessoSoggiorno",
                            e.target.checked
                          )
                        }
                        checked={formData.possessoPermessoSoggiorno}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="possessoPermessoSoggiorno"
                      >
                        possesso Permesso Soggiorno
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="possessoCartaSoggiorno"
                        onChange={(e) =>
                          handleChangeCheckbox(
                            "possessoCartaSoggiorno",
                            e.target.checked
                          )
                        }
                        checked={formData.possessoCartaSoggiorno}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="possessoCartaSoggiorno"
                      >
                        possesso Carta Soggiorno
                      </label>
                    </div>

                    {/*  comuneResidenza:'',
  telefono:'',
  sesso:'',
  domicilio:'',
  codiceFiscale:'',
  cittadinanzaItaliana:1,
  altraCittadinanza:0,
  possessoPermessoSoggiorno:0,
  possessoCartaSoggiorno:0,
  statoCivile:0, */}
                    <div className="it-card-footer">
                      <span className="card-signature">
                        {error && (
                          <div className="alert alert-danger mt-2" role="alert">
                            <b>Attenzione:</b> {error}.
                          </div>
                        )}
                      </span>

                      
                        <button
                          className="btn btn-outline-primary"
                          type="button"
                          onClick={handleUpdate}
                        >
                          Salva
                        </button>
                    
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!loading && <Loader></Loader>}
    </>
  );
}

export default AddAssistito;